import {MenuItemConfigReaderBase} from "./menu-item-config-reader-base";
import {
    MenuItemsConfiguration
} from "../../configurations/config-data-sections/menu-items.configuration";
import {MenuItemAnalyticsCategoryAndLabel} from "./menu-item-config-reader.interface";

export class MenuItemDefaultConfigReader extends MenuItemConfigReaderBase {
    protected _getMenuItemsConfigOverrides(): MenuItemsConfiguration | undefined {
        return undefined;
    }

    protected _getAnalyticsCategoryAndLabel(): MenuItemAnalyticsCategoryAndLabel | null {
        return null;
    }
}